import { cn } from '@salesbee/ui';

/** The WRKRBZ mark (rounded hexagon with "WB" and the honey dot), shared by every Bee. */
export const MARK_PATHS = {
  hexagon:
    'M91.00 43.07Q95.00 50.00 91.00 56.93L76.50 82.04Q72.50 88.97 64.50 88.97L35.50 88.97Q27.50 88.97 23.50 82.04L9.00 56.93Q5.00 50.00 9.00 43.07L23.50 17.96Q27.50 11.03 35.50 11.03L64.50 11.03Q72.50 11.03 76.50 17.96Z',
  w: 'M23.5 36L30 64L36.5 44.96L43 64L49.5 36',
  b: 'M56 36V64M56 36H65C70.5 36 73 39 73 43C73 47 70.5 50 65 50H56M56 50H66.5C72 50 75 53 75 57C75 61 72 64 66.5 64H56',
} as const;

export const HONEY = '#F2C12E';

export function Logo({ className, label = 'SalesBee' }: { className?: string; label?: string }) {
  return (
    <svg viewBox="0 0 100 100" className={cn('size-8 text-foreground', className)} {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}>
      <path d={MARK_PATHS.hexagon} fill="none" stroke="currentColor" strokeWidth={3.2} />
      <path d={MARK_PATHS.w} fill="none" stroke="currentColor" strokeWidth={5.4} strokeLinecap="round" strokeLinejoin="round" />
      <path d={MARK_PATHS.b} fill="none" stroke="currentColor" strokeWidth={5.4} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="72.5" cy="11" r={6.5} fill={HONEY} />
    </svg>
  );
}

/**
 * The WRKRBZ mark plus the product name: every brand spot (shell, pricing, onboarding, auth). A
 * workspace's own logo, if one is ever shown, goes beside this after a thin divider, never in place
 * of it.
 */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5 font-display text-[19px] font-semibold tracking-[-0.01em]', className)}>
      <Logo className="size-8 shrink-0" label="" /> SalesBee
    </span>
  );
}

/** Stacked mark and product name above the auth card (sign-in, sign-up, reset, invitations). */
export function AuthBrand() {
  return (
    <span className="flex flex-col items-center gap-2 font-display text-[19px] font-semibold tracking-[-0.01em]">
      <Logo className="size-12" label="" /> SalesBee
    </span>
  );
}
